
import { defineComponent, onBeforeMount } from 'vue'

const TABS = [
    { id: 'general', name: 'Основная информация' },
    { id: 'payment', name: 'Оплата' },
]

export default defineComponent({
    props: {
        value: {
            type: String,
            default: null,
        },
        isNeedCar: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const isTabSelected = (tab: { id: string }) => {
            if (!props.value) return false
            return props.value === tab.id
        }

        const selectTab = (tab: { id: string }) => {
            if (isTabSelected(tab)) return
            emit('update:value', tab.id)
            emit('change', tab.id)
        }

        const checkCar = () => {
            const vehicleTab = TABS.find((tab) => tab.id === 'vehicle-information')
            const servicesTab = TABS.find((tab) => tab.id === 'additional-services')

            if (props.isNeedCar && !vehicleTab) {
                TABS.push({ id: 'vehicle-information', name: 'Информация о машине' })
            }

            if (!servicesTab) {
                TABS.push({ id: 'additional-services', name: 'Доп. услуги' })
            }
        }

        onBeforeMount(checkCar)

        return {
            isTabSelected,
            selectTab,
            TABS,
        }
    },
})
